import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './NotasFiscaisLayout.module.css';
export function NotasFiscaisLayout() {
    return (_jsx("div", { className: styles.wrapper, children: _jsx(Outlet, {}) }));
}
export default NotasFiscaisLayout;
